module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_search.83276.png";